'use strict';

var customertable = angular.module('gymsystem.customertable', []);

customertable.directive('customertable', ['$rootScope', '$parse', '$filter', '$compile', '$q', 'formatter', 'pdf', 'excel', 'server', 'live', '$timeout', 'util', '$location', '$modal', 'pubsub', function ($rootScope, $parse, $filter, $compile, $q, formatter, pdf, excel, server, live, $timeout, util, $location, $modal, pubsub) {
    return {
        restrict: 'E',
        scope: {
            config: '=',
            control: '=?'
        },
        link: function(scope, element) {
            // Set values in scope from $rootScope to get form.html to work
            scope.getCustomerForField = $rootScope.getCustomerForField;
            scope.getCustomersForField = $rootScope.getCustomersForField;
            scope.getItemListText = $rootScope.getItemListText;

            var getFilterSubmitArgs = function() {
                var item = {};
                for (var i = 0; i < (scope.config.filter || []).length; ++i) {
                    var field = scope.config.filter[i];
                    if (field.type == 'label' || field.readonly) {
                        continue;
                    }
                    var value;
                    if (field.visible && !field.visible()) {
                        value = null;
                    }

                    if (field.getValue) {
                        value = field.getValue(field);
                    } else {
                        if (field.useId) {
                            if (Array.isArray(field.value)) {
                                value = _.pluck(field.value, 'id');
                            } else {
                                value = field.value && field.value.id;
                            }
                        } else if (field.type == 'date') {
                            value = field.value  && field.value.yyyymmdd();
                        } else if (field.type == 'time') {
                            value = field.value && field.value.hhmm();
                        } else {
                            value = field.value;
                        }
                    }

                    if (field.name.indexOf('.') != -1) {
                        var parts = field.name.split('.');
                        if (!item[parts[0]]) {
                            item[parts[0]] = {};
                        }
                        item[parts[0]][parts[1]] = value;
                    } else {
                        item[field.name] = value;
                    }
                }

                angular.extend(item, Object.fromEntries(Object.entries(scope.config.api.args ?? {}).map(([key, value]) => {
                    return [key, typeof value === 'function' ? value() : value];
                })));

                return item;
            };

            var hasMissingRequiredField = function() {
                for (var i = 0; i < (scope.config.filter || []).length; ++i) {
                    var field = scope.config.filter[i];
                    if (field.required && !field.value) {
                        return true;
                    }
                }
                return false;
            };

            var saveFilterArgs = function(args) {
                if (!scope.config.saveFilter) {
                    return;
                }

                try {
                    localStorage.setItem(scope.config.saveFilter, JSON.stringify(args));
                }
                catch (e) { /* Ignore */ }
            };

            var filterArgsLoaded = false;
            var loadFilterArgs = function() {
                if (!scope.config.saveFilter || filterArgsLoaded) {
                    return;
                }

                try {
                    const args = JSON.parse(localStorage.getItem(scope.config.saveFilter));
                    util.setValues(scope.config.filter, args);
                }
                catch (e) { /* Ignore */ }
                filterArgsLoaded = true;
            };

            var getApiItems = function() {
                loadFilterArgs();
                if (hasMissingRequiredField()) {
                    return $q.when([]);
                }

                const args = getFilterSubmitArgs();
                saveFilterArgs(args);

                if (scope.config.api.post) {
                    return server.post(scope.config.api.url, args, undefined, undefined, undefined, undefined, scope.cancelPreviousRequest ? {timeout: scope.cancelPreviousRequest.promise} : undefined).then(function(response) {
                        let items;
                        if (!response.success || !response.data) {
                            items = []
                        } else {
                            items = scope.config.api.getItemsFromResponse ? scope.config.api.getItemsFromResponse(response) : response.data;
                        }
                        if (scope.config.api.itemField) {
                            items = items[scope.config.api.itemField];
                        }
                        if (scope.config.api.transform) {
                            items.forEach(scope.config.api.transform);
                        }
                        if (scope.config.api.onItemsUpdated) {
                            scope.config.api.onItemsUpdated(items);
                        }
                        return items;
                    });

                } else {
                    return server.get(scope.config.api.url, args, scope.cancelPreviousRequest).then(function(items) {
                        if (scope.config.api.itemField) {
                            items = items[scope.config.api.itemField];
                        }
                        if (scope.config.api.transform) {
                            items.forEach(scope.config.api.transform);
                        }
                        if (scope.config.api.onItemsUpdated) {
                            scope.config.api.onItemsUpdated(items);
                        }
                        return items;
                    });
                }
            };

            var updateApiItems = function() {
                if (scope.cancelPreviousRequest) {
                    scope.cancelPreviousRequest.resolve();
                }
                scope.cancelPreviousRequest = $q.defer();

                scope.apiitemspromise = getApiItems();
                return scope.apiitemspromise;
            };

            var configChanged = function() {
                var triggers = scope.config.triggers || ["user", "image"];
                scope.orderColumn = scope.config.orderColumn;
                scope.fields = scope.config.filter;

                // Unsubscribe
                if (scope.apiTriggers) {
                    scope.apiTriggers.forEach(function(t) {
                        t();
                    });
                }

                if (!scope.config.getItems && scope.config.api) {
                    scope.config.getItems = function() {
                        if (scope.config.api.initialItems && !scope.apiitemspromise) {
                            scope.apiitemspromise = $q.when(scope.config.api.initialItems());
                            return scope.apiitemspromise;
                        }
                        if (!scope.apiitemspromise) {
                            return updateApiItems();
                        }

                        return scope.apiitemspromise;
                    };

                    (scope.config.filter || []).forEach(function(field) {
                        if (field.change) {
                            var oldChange = field.change;
                            field.change = function() {
                                oldChange();
                                updateApiItems();
                            };
                        } else {
                            field.change = updateApiItems;
                        }
                    });

                    if (scope.config.api.triggers) {
                        var apiUpdate = updateApiItems;
                        if (scope.config.api.debounce) {
                            if(scope.config.api.debounce == 'queue') {
                                apiUpdate = (function(fn) {
                                    var next;
                                    return function() {
                                        if(scope.apiitemspromise && scope.apiitemspromise.finally) {
                                            next = fn;
                                            scope.apiitemspromise.finally(function() {
                                                if(next) {
                                                    next();
                                                    next = null;
                                                }
                                            });
                                        } else {fn();}
                                    };
                                })(apiUpdate);
                            } else {
                                apiUpdate = _.debounce(apiUpdate, scope.config.api.debounce);
                            }
                        }
                        scope.apiTriggers = [];
                        scope.config.api.triggers.forEach(function(t) {
                            if (t.type == 'selectedSite') {
                                pubsub.subscribe('selectedSite', apiUpdate)
                                var unsubscribe = () => pubsub.unsubscribe('selectedSite', apiUpdate);
                                scope.apiTriggers.push(unsubscribe);
                            } else {
                                scope.apiTriggers.push( live.subscribe( {type: t.type, scope: scope, callback: function(ignore, event) {
                                    var dirty = !t.condition || _.find(event.data, function(data) {
                                        return t.condition(data);
                                    });
                                    if (dirty) {
                                        apiUpdate();
                                    }
                                }}));
                            }
                        });
                    }
                }
                if (scope.config.countSuffixList) {
                    scope.config.countSuffix = function() {
                        var s = scope.config.countSuffixList[scope.config.control.getNumberOfFilteredItems() == 1 ? 0 : 1];
                        return $filter('translate')(s).toLowerCase();
                    };
                }
                scope.hideSubmitButton = true;

                scope.currentPage = 0;
                scope.pagedItems = [];
                var ITEMS_PER_PAGE = scope.config.tableLimit || 75;
                var NUM_PAGES = scope.config.tableNumPages || 10;

                scope.prevPage = function () {
                    if (scope.currentPage > 0) {
                        scope.setPage(scope.currentPage - 1);
                    }
                };

                scope.nextPage = function () {
                    if (scope.currentPage < scope.getPageCount() - 1) {
                        scope.setPage(scope.currentPage + 1);
                    }
                };

                var asyncLoadedPage, asyncLoadedItems;

                scope.setPage = function (n) {
                    scope.currentPage = n;
                    if(scope.config.async) {
                        return scope.config.async.fetchPage({
                            offset: ITEMS_PER_PAGE * n,
                            limit: ITEMS_PER_PAGE,
                            order: scope.orderColumn
                        }).then(function(response) {
                            asyncLoadedPage = n;
                            asyncLoadedItems = response;
                            scope.updateTable(false);
                        });
                    }
                    scope.updateTable(false);
                };

                function getPageItems(n) {
                    if(asyncLoadedItems) {
                        if(n !== asyncLoadedPage) {console.warn('Wrong loaded page');}
                        return asyncLoadedItems;
                    }
                    return scope.pagedItems[n] || [];
                }

                scope.getPageCount = function() {
                    if(scope.config.async && scope.config.async.count) {
                        return Math.ceil(scope.config.async.count / ITEMS_PER_PAGE);
                    }
                    return scope.pagedItems.length;
                };

                scope.showPagination = function() {
                    return !scope.config.hidePagination;
                };

                scope.getPages = function() {
                    var pageCount = scope.getPageCount();
                    var start = Math.max(0, Math.min(scope.currentPage - Math.floor(NUM_PAGES/2), pageCount - NUM_PAGES));
                    var end = Math.min(pageCount, start + NUM_PAGES);
                    var ret = [];
                    for (var i = start; i < end; i++) {
                        ret.push(i);
                    }
                    return ret;
                };

                var idKey = scope.config.idKey || 'id';
                scope.getItem = function(id) {
                    var filter = {};
                    filter[idKey] = id;
                    if(asyncLoadedItems) {
                        return _.findWhere(asyncLoadedItems, filter);
                    }
                    return _.findWhere(scope.items, filter);
                };

                scope.groupToPages = function () {
                    scope.pagedItems = [];

                    for (var i = 0; i < scope.filtered.length; i++) {
                        if (i % ITEMS_PER_PAGE === 0) {
                            scope.pagedItems[Math.floor(i / ITEMS_PER_PAGE)] = [ scope.filtered[i] ];
                        } else {
                            scope.pagedItems[Math.floor(i / ITEMS_PER_PAGE)].push(scope.filtered[i]);
                        }
                    }
                };

                scope.setOrder = function(columnIndex) {
                    // Overrides the order column set initially with config.orderColumn
                    var column = scope.config.columns[columnIndex];
                    var columnName = column.field;

                    if (scope.orderColumn) {
                        var currentColumnName = scope.orderColumn.replace('-', '');
                        if (currentColumnName == columnName) {
                            // Toggle
                            scope.orderColumn = (scope.orderColumn.indexOf('-') == 0 ? '' : '-') + currentColumnName;
                        } else {
                            scope.orderColumn = columnName;
                        }
                    } else {
                        scope.orderColumn = columnName;
                    }

                    if(scope.config.async) {
                        scope.setPage(0);
                    } else {
                        scope.updateTable(true);
                    }
                };

                var objectToStyleExpression = function(o) {
                    if (_.isEmpty(o)) {
                        return '';
                    }

                    var style = ' style="';
                    for (var p in o) {
                        var value = o[p];
                        style += p + ':' + value + ';';
                    }
                    style += '"';
                    return style;
                };

                var functionToStyleExpression = function (m, styleFunction) {
                    return objectToStyleExpression(styleFunction(m));
                };

                var DEFAULT_COLOR_BOX_STYLE = 'height: 25px; width: 15%; max-width: 25px; padding-right: 5px; padding-top: 5px; float: left; margin-right: 5px; border-radius: 8px';

                // A column with a `color` function gets a box in front of its value. Its
                // shape is the directive's to decide, so a column may override the style
                // but never has to repeat the default.
                //
                // Columns that bring their own style are laid out with flex, which centres
                // the box against the line box. The default geometry stays on the original
                // float instead: floats are ignored inside a flex container, so wrapping it
                // too would silently reshape the boxes that already rely on it.
                var withColorBox = function(c, m, value) {
                    var background = 'background-color:' + c.color(m) + '; ';

                    if (!c.colorStyle) {
                        return '<div style="' + background + DEFAULT_COLOR_BOX_STYLE + '">  </div>' + value;
                    }

                    return '<div style="display: flex; align-items: center">' +
                        '<div style="' + background + c.colorStyle + '"></div>' +
                        '<span style="min-width: 0">' + value + '</span>' +
                        '</div>';
                };

                var createTable = function() {
                    var html = '';

                    if (scope.config.templateUrl) {
                        html += '<div static-include="' + scope.config.templateUrl + '"></div>';
                    } else {
                        if (scope.config.filter && scope.config.filter.length) {
                            html += '<div class="row"><div ng-class="config.getFilterClass ? config.getFilterClass() : \'col-lg-6\'" static-include="views/form.html"></div>'

                            if (scope.config.filterButtons) {
                                html += '<div class="col-lg-6">';
                                for (var i=0; i < scope.config.filterButtons.length; ++i) {
                                    var button = scope.config.filterButtons[i];
                                    let visible = 'config.filterButtons[' + i + '].visible ? config.filterButtons[' + i + '].visible() : true';

                                    html += '<button class="btn btn-success btn-block-mobile btn-spacing" ng-click="config.filterButtons[' + i + '].onClick()" ng-show="' + visible + '" >{{"' + button.title + '" | translate}}</button>';
                                }
                                html += '</div>';
                            }
                            html += '</div>';
                        }
                        html += '<div class="table-dynamic"><div class="row" style="margin-bottom: 15px">';

                        if (scope.config.bannerDirective) {
                            html += '<'+ scope.config.bannerDirective +' config="config" />';
                        }

                        if (scope.config.tableInfo) {
                            html += '<div style="margin: 1em;" ng-show="config.tableInfo()" class="alert alert-info">{{config.tableInfo()|translate}}</div>';
                        }

                        if (scope.config.empty) {
                            html += '<div ng-get-element="config.empty.element" ng-if="config.control.emptyStateVisible()" style="padding-left: 1em;">';
                            html += '<div ng-if="config.empty.getTitle || config.empty.title"><p style="font-size: large; font-family: Arial;">{{(config.empty.getTitle ? config.empty.getTitle(): config.empty.title) | translate}}</p></div>';
                            html += '<div ng-if="config.empty.getText || config.empty.text"><p>{{(config.empty.getText ? config.empty.getText() : config.empty.text) | translate}}</p></div>';
                            html += '<div ng-if="config.empty.button"><button class="btn btn-success btn-block-mobile" ng-click="config.empty.button.onClick()">{{config.empty.button.title | translate}}</button></div>';
                            html += '</div>';
                        }

                        if (!scope.config.hideSearch) {
                            html += '<div ng-show="(config.empty ? config.control.getNumberOfItems() : true) && (config.searchBarVisible ? config.searchBarVisible() : true)" static-include="views/search.html"></div>';
                        }

                        var striped = scope.config.striped == undefined || scope.config.striped == true;
                        var bordered = scope.config.bordered == undefined || scope.config.bordered == true;
                        var style = objectToStyleExpression(scope.config.style);
                        var overflow = scope.config.tableOverflow || 'auto';

                        if (scope.config.correctionWidth) {
                            html += '</div><div class="panel panel-default" ng-show="filtered.length" style="display: inline-block; max-width: 100%;"><div class="table-responsive" style="overflow-x: '+overflow+'"><table class="table' + (bordered ? ' table-bordered' : '')  + (striped ? ' table-striped' : '') +'" ' + style + ' style="width: auto;"">';

                        } else {
                            html += '</div><div class="panel panel-default" ng-show="filtered.length"><div class="table-responsive" style="overflow-x: '+overflow+'"><table class="table' + (bordered ? ' table-bordered' : '')  + (striped ? ' table-striped' : '') +'" ' + style + '>';
                        }

                        var numColumns = 0;
                        var isMobile = $rootScope.isMobile && $rootScope.isMobile() && scope.config.renderHtmlMobile;
                        var header = '';
                        var showHeader = (scope.config.showHeader == undefined || scope.config.showHeader) && !isMobile;
                        var showSum = scope.config.showSum === undefined ? showHeader : scope.config.showSum;

                        if (showHeader) {
                            html += '<thead><tr>';

                            var columns = scope.config.columns;
                            for (var i=0; i < columns.length; ++i) {
                                var c = columns[i];
                                var text = c.title || '';
                                var headerBtn = '';
                                if (c.field && scope.config.showMailing) {
                                    var fieldParts = c.field.split('.');
                                    if (_.contains(fieldParts, 'mail')) {
                                        headerBtn = '<btn class="btn btn-success btn-xs" style="margin-left: 1ex;" ng-click="config.control.sendMailing(\''+c.field+'\', \'mail\')">{{"Send mailing" | translate}}</btn>';
                                    } else if (_.contains(fieldParts, 'phone')) {
                                        headerBtn = '<btn class="btn btn-success btn-xs" style="margin-left: 1ex;" ng-click="config.control.sendMailing(\''+c.field+'\', \'sms\')">{{"Send SMS" | translate}}</btn>';
                                    }
                                }

                                if (c.field == 'image') {
                                    header += '<th style="width:50px"><div class="th">{{"' + text + '"|translate}}</div></th>';
                                    ++numColumns;
                                } else if (!c.visible || c.visible(scope.config, c)) {
                                    if (c.color) {
                                        header += '<th><div class="th" style="min-width:150px"><a href="" ng-click="setOrder(' + i + ')">{{"' + text + '"|translate}}</a>'+headerBtn+'</div></th>';
                                    } else {
                                        header += '<th><div class="th"><a href="" ng-click="setOrder(' + i + ')">{{"' + text + '"|translate}}</a>'+headerBtn+'</div></th>';
                                    }
                                    ++numColumns;
                                }
                            }
                            if (scope.config.buttons) {
                                var buttonwidth = 0;
                                for (var b=0; b < scope.config.buttons.length; ++b) {
                                    var button = scope.config.buttons[b];
                                    if (button.title) {
                                        buttonwidth = 0;
                                        break;
                                    }
                                    else {
                                        var sms = $rootScope.hasModule('SMS');
                                        var booking = $rootScope.hasPermission('Workout booking');
                                        buttonwidth = (2 + booking + sms) * 30;
                                        break;
                                    }
                                }
                                if (buttonwidth) {
                                    header += '<th width="' + buttonwidth + '"></th>';
                                } else {
                                    header += '<th></th>';
                                }
                                ++numColumns;
                            }

                            if (scope.config.multibutton) {
                                header += '<th width="100"></th>';
                                ++numColumns;
                            }

                            html += header;

                            html += '</tr></thead>';
                        } else {
                            var columns = scope.config.columns;
                            for (var i=0; i < columns.length; ++i) {
                                var c = columns[i];
                                if (c.field == 'image') {
                                    ++numColumns;
                                } else if (!c.visible || c.visible(scope.config, c)) {
                                    ++numColumns;
                                }
                                if (scope.config.buttons) {
                                    ++numColumns;
                                }
                            }
                        }

                        html += '<tfoot ng-if="getPageCount() > 1 && showPagination()"><td colspan="' + numColumns + '"><div class="pull-right float-none-mobile"><ul class="pagination"><li ng-class="{disabled: currentPage == 0}"><a style="white-space:nowrap" href ng-click="prevPage()">« {{\'Previous\' | translate}}</a></li><li ng-repeat="n in getPages()" ng-class="{active: n == currentPage}" ng-click="setPage(n)">';
                        html += '<a href ng-bind="n + 1">1</a></li><li ng-class="{disabled: currentPage == getPageCount() - 1}"><a style="white-space:nowrap" href ng-click="nextPage()">{{\'Next\' | translate}} »</a></li></ul></div></td></tfoot>';

                        html += '<tbody class="inner-customer-table"></tbody>';
                        if (showSum) {
                            html += '<tfoot class="sum-footer" ng-show="filtered.length >= 2"><tr>' + header + '</tr></tfoot>';
                        }
                        html += '</table></div></div>';
                    }

                    var e = angular.element(html);
                    element.empty();
                    element.append(e);
                    $compile(e)(scope);
                };

                var isSearchableProperty = function(o) {
                    return (['icalendar', 'resourceType'].indexOf(o)) == -1;
                };

                var shallowComparator = function(obj, text, depth) {
                    if (!text || !obj) {
                        return false;
                    }
                    if (typeof obj === 'object') {
                        if (depth) {
                            return _.keys(obj).filter(isSearchableProperty).some(function(k) { var o = obj[k]; return shallowComparator(o, text, depth-1); });
                        }
                        return false;
                    }
                    var tempText = (''+text).replace(/[\s\-]/g, '').toLowerCase();
                    if (isNaN(tempText)) {
                        return (''+obj).toLowerCase().indexOf(text.toLowerCase()) > -1 || (''+$filter('translate')(obj)).toLowerCase().indexOf(text.toLowerCase()) > -1;
                    } else {
                        return (''+obj).replace(/[\s\-]/g, '').toLowerCase().indexOf(tempText) > -1;
                    }
                };

                var shallowSearch = function(obj, text, depth) {
                    var res = shallowComparator(obj, text, depth);
                    if (!res && obj.xf) {
                        res = shallowComparator(obj.xf, text, 1);
                    }
                    return res;
                };

                // Search function for user objects. Uses the fields list to determine which properties to search through
                var customerSearch = function(items, text) {
                    var compare = function(obj, textLower, number) {
                        if (number === undefined) {
                            return (''+obj).toLowerCase().indexOf(textLower) > -1;
                        } else {
                            return (''+obj).replace(/[\s\-]/g, '').toLowerCase().indexOf(number) > -1;
                        }
                    };

                    var fields = $rootScope.fields.user.filter(function(x) {
                        return x.show &&
                        !(x.builtIn && x.name == 'firstname') &&
                        !(x.builtIn && x.name == 'lastname') &&
                          ['multicheckbox', 'checkbox', 'select', 'password', 'image', 'customer', 'site', 'usergroups'].indexOf(x.type) == -1;
                    });

                    fields.unshift({name: 'quickSearchFullname', builtIn: true});
                    fields.unshift({name: 'fullname', builtIn: true});
                    fields.unshift({name: 'entry_card_value', builtIn: true});

                    text = text.toLowerCase();
                    var tempText = (''+text).replace(/[\s\-]/g, '');
                    var isNumber = !isNaN(tempText);
                    var number = isNumber ? tempText : undefined;

                    return items.filter(function(item) {
                        for (var i=0; i < fields.length; ++i) {
                            var field = fields[i];
                            var value = field.builtIn ? item[field.name] : (item.xf && item.xf[field.name]);
                            if (value && compare(value, text, number)) {
                                return true;
                            }
                        }
                    });
                };

                var addPlaceholder = function(obj) {
                    let addForObject = function(obj) {
                        if (obj && obj.id && obj.is_placeholder) {
                            if (!scope.renderedPlaceholders) {
                                scope.renderedPlaceholders = new Set();
                            }
                            scope.renderedPlaceholders.add(obj.uid);
                        }
                    };
                    if (Array.isArray(obj)) {
                        obj.forEach(addForObject);
                    } else {
                        addForObject(obj);
                    }
                }

                var getDescendantProp = function (obj, desc) {
                    var arr = Array.isArray(desc) ? angular.copy(desc) : desc.split(".");
                    while(arr.length && (obj = obj[arr.shift()])) {
                        addPlaceholder(obj);
                    }
                    addPlaceholder(obj);
                    return obj;
                };

                var getRawValueForColumn = function(obj, column) {
                    if (column.placeHolderUid) {
                        let uid = column.placeHolderUid(obj);
                        if (uid) {
                            addPlaceholder({id: uid, uid, is_placeholder: true});
                        }
                    }

                    var value;
                    addPlaceholder(obj);
                    if (column.getValue) {
                        value = column.getValue(obj);
                        // The following row is needed to add placeholders when a getValue function is used
                        // This way at least the obj[column.field] is treated (but getValue could reference other things ofcourse
                        // which will not be handled
                        getDescendantProp(obj, (column.splitted_name && column.splitted_name.length) ? column.splitted_name : column.field);

                        // Defense: scan common nested properties that getValue functions often access
                        // This catches cases like getValue: (wb) => wb.user.name when field is 'name' instead of 'user.name'
                        // Note: addPlaceholder handles arrays internally, so we can pass arrays directly
                        var commonUserProps = ['user', 'staff', 'customer', 'member', 'payer', 'responsible', 'creator', 'sender', 'performer', 'receiver', 'booker', 'owner', 'instructor', 'users', 'staffs', 'members'];
                        commonUserProps.forEach(function(prop) {
                            if (obj[prop]) {
                                addPlaceholder(obj[prop]);
                            }
                        });
                    } else if (column.format == 'image' && column.text) {
                        value = column.text(obj);
                    } else {
                        value = getDescendantProp(obj, (column.splitted_name && column.splitted_name.length) ? column.splitted_name : column.field);
                    }
                    return value;
                };

                // The row HTML is $compiled, so text from users must not be read as Angular expressions.
                var asInertText = function(rawText) {
                    return '<span ng-non-bindable>' + util.escapeHtml(rawText) + '</span>';
                };

                var getValueForColumn = function(obj, column, ignoreFormat) {
                    var value = getRawValueForColumn(obj, column);
                    if (!ignoreFormat) {
                        let extra = column.getExtraValue && column.getExtraValue(obj);
                        value = formatter.format(column.getFormat ? column.getFormat(obj) : column.format, value, extra);
                    }
                    if (value == undefined || value == null) {
                        value = '';
                    }
                    if (!_.isString(value)) {
                        value = String(value);
                    }
                    return value;
                };

                var getButtonStyle = function() {
                    for (var b=0; b < scope.config.buttons.length; ++b) {
                        var button = scope.config.buttons[b];
                        if (button.title) {
                            return 'btn-toolbar';
                        }
                    }

                    return 'btn-group';
                };

                var searchFilter = function(obj) {
                    var a = getDescendantProp(obj, scope.config.searchField.id);
                    if (a == undefined || a == null) {
                        return false;
                    }

                    var b = scope.config.searchText.toLowerCase();
                    if (scope.config.searchField.type == 'list' && a.length) {
                        return $filter('filter')(a, scope.config.searchText).length;
                    }

                    a = String(a).toLowerCase();
                    return a.indexOf(b) != -1;
                };

                var renderHtmlMobile = function() {
                    var html = '';
                    var focusid = 1;
                    var isMobile = $rootScope.isMobile && $rootScope.isMobile();

                    var buttonImageSrces = [];
                    var tooltips = [];
                    if (scope.config.buttons) {
                        for (var i=0; i < scope.config.buttons.length; ++i) {
                            var button = scope.config.buttons[i];
                            buttonImageSrces.push(button.imageSrc && button.imageSrc());
                            tooltips.push($filter('translate')(button.tooltip));
                        }
                    }

                    var columns = scope.config.columns;
                    var currentPageItems = getPageItems(scope.currentPage);

                    var showColorBox = {};
                    columns.forEach(function(column, i) {
                        if(!column.color) {return;}
                        if(column.visible && !column.visible(scope.config, column)) {return;}
                        showColorBox[i] = currentPageItems.some(column.color);
                    });

                    for (var i=0; i < currentPageItems.length; ++i) {
                        var m = currentPageItems[i];
                        var get = '';
                        if (angular.isString(m[idKey])) {
                            get = 'getItem(\'' + m[idKey] + '\')';
                        } else {
                            get = 'getItem(' + m[idKey] + ')';
                        }
                        var rowclick = '';
                        rowclick = ' ng-click="config.selected = ( config.selected == ' + m[idKey] + ' ? undefined : ' + m[idKey] + ')"';
                        if (scope.config.rowMouseDown && m[idKey] != undefined) {
                            rowclick = ' ng-mousedown="config.rowMouseDown(' + get + ')" class="clickable"';
                        }

                        var rc = scope.config.rowClass ? scope.config.rowClass(m) : '';
                        var rowstyle = '';
                        if (scope.config.getRowStyle) {
                            var style = scope.config.getRowStyle(i+1);
                            if (style) {
                                rowstyle = ' ' + objectToStyleExpression(style);
                            }
                        }
                        var popover = '';
                        if (scope.config.getCustomer && !$rootScope.isSmallScreen()) {
                            popover = ' ng-mouseover="showPopover(' + m.id + ')" ng-mouseleave="hidePopover()" ';
                        }

                        html += '<tr' + popover + (rc ? (' class="' + rc + '"') : '') + rowstyle + '><td>';

                        var visible = 0;
                        for (var j=0; j < columns.length; ++j) {
                            var c = columns[j];
                            if (!c.visible || c.visible(scope.config, c)) {
                                visible ++;
                                var ngShow  = '';
                                if (visible > (scope.config.numOfVisibleColumns ? scope.config.numOfVisibleColumns : 2)) {
                                    ngShow = 'ng-show="config.selected == ' + m[idKey] + '"';
                                }
                                var format = c.getFormat ? c.getFormat(m) : c.format;
                                if (c.field == 'image' || (c.field.indexOf('image') != -1 && c.src) || format == 'image') {
                                    var imgSrc = c.src ? c.src(m) : $rootScope.smallMemberImage(m);
                                    var imgSize = c.size ? c.size(m) : '50px';
                                    if(imgSrc) {
                                        imgSrc = '<img style="width: ' + imgSize + '; height: ' + imgSize + '" src="' + imgSrc + '">';
                                    } else {
                                        imgSrc = '';
                                    }
                                    if (c.text) {
                                        var style = objectToStyleExpression(c.style);
                                        var text = asInertText(c.text(m));
                                        if (c.linebreak) {
                                            imgSrc = '<table><tr><td>' + imgSrc + '</td><td style="padding-left: 10px">';
                                            text = text.replaceAll('\n', '<br/>');
                                            imgSrc += '<span ' + style + '>' + text + '</span></td></tr></table>';

                                        } else {
                                            imgSrc += '<span style="margin-left: 10px"' + style + '>' + text + '</span>';
                                        }
                                    }

                                    html += '<div style="padding:2px"' + ngShow + rowclick + '>' + imgSrc + '</div>';
                                } else if (format == 'editable') {
                                    var onChange = '';
                                    if (c.change && m[idKey] != undefined) {
                                        onChange = 'config.columns[{0}].change({1})'.format(j, get);
                                    }

                                    var editableType = c.editableType || 'text';
                                    var placeholder = c.editablePlaceholder ? ' placeholder="' + c.editablePlaceholder + '" ' : '';
                                    var min = c.editableType == 'number' ? ' min="0" ' : '';
                                    html += '<div ' + ngShow + '><strong>{{"'+ c.title +'"|translate}}</strong><input class="form-control" data-focusid="' + focusid + '" type="' + editableType + '" ng-change="' + onChange + '" ng-model-options="{ debounce: 200 }" ng-model="' + get + '[\'' + c.field + '\']' + placeholder + min +'"></div>';
                                    ++focusid;
                                } else if (format == 'checkbox') {
                                    html += '<div ' + ngShow + '><input type="checkbox" ng-change="config.columns[' + j + '].change(' + get + ')" ng-model="' + get + '[\'' + c.field + '\']" class="form-control" style="min-width: 8px; min-height: 8px; max-width: 18px; min-width: 18px; margin-left: 15%;"></div>';
                                } else {
                                    if (c.field.startsWith('xf') && !c.splitted_name) {
                                        c.splitted_name = ['xf', c.field.substr(3)];
                                    }
                                    var value = getValueForColumn(m, c);
                                    if (!c.showHtml && !formatter.requiresHtml(format)) {
                                        value = asInertText(value);
                                    }
                                    if (typeof c.style === "function") {
                                        var style = functionToStyleExpression(m, c.style);
                                    } else {
                                        var style = objectToStyleExpression(c.style);
                                    }

                                    if(showColorBox[j]) {
                                        value = withColorBox(c, m, value);
                                    }

                                    if (c.click) {
                                        rowclick = ' ng-click="config.columns[{0}].click({1})" '.format(j, get);
                                    }

                                    html += '<div ' + ngShow + style + rowclick + '><strong class="col-xs-4">{{"'+ c.title +'"|translate}}: </strong><span class="col-xs-8">' + value + '</span></div>';
                                }
                            }
                        }

                        if (scope.config.buttons) {
                            var buttons = '<div ng-show="config.selected == ' + m[idKey] + '" class="' + getButtonStyle() + '" style="white-space:nowrap">';
                            for (var b=0; b < scope.config.buttons.length; ++b) {
                                var button = scope.config.buttons[b];

                                if (!button.visible || button.visible(m, scope.config)) {
                                    if (button.title) {
                                        var buttonClass = button.buttonClass || 'btn-success';
                                        var loading = button.loading ? 'ladda="config.buttons[' + b + '].loading(' + get + ')" data-style="expand-left"' : '';
                                        buttons += '<button class="btn ' + buttonClass + ' btn-block-mobile" ' + loading + ' ng-click="config.buttons[' + b + '].onClick(' + get + ')">' + $filter('translate')(button.title) + '</button>';
                                    }
                                    else {
                                        var imgSrc = buttonImageSrces[b];
                                        var tooltip = isMobile ? '' : 'tooltip="' + tooltips[b] + '"';
                                        buttons += '<a href="" ng-click="config.buttons[' + b + '].onClick(' + get + ')" ' + tooltip + '><img src="' + imgSrc + '"></img></a>';
                                    }
                                }
                            }

                            buttons += '</div>';
                            html += '<div>' + buttons + '</div>';
                        }

                        html += '</td></tr>';
                    }

                    return html;
                };

                var renderHtml = function() {
                    var html = '';
                    var focusid = 1;
                    var isMobile = $rootScope.isMobile && $rootScope.isMobile();
                    if (scope.config.renderHtmlMobile) {
                        return renderHtmlMobile();
                    }

                    var buttonImageSrces = [];
                    var tooltips = [];
                    if (scope.config.buttons) {
                        for (var i=0; i < scope.config.buttons.length; ++i) {
                            var button = scope.config.buttons[i];
                            buttonImageSrces.push(button.imageSrc && button.imageSrc());
                            tooltips.push($filter('translate')(button.tooltip));
                        }
                    }

                    var columns = scope.config.columns;
                    var currentPageItems = getPageItems(scope.currentPage);

                    var showColorBox = {};
                    columns.forEach(function(column, i) {
                        if(!column.color) {return;}
                        if(column.visible && !column.visible(scope.config, column)) {return;}
                        showColorBox[i] = currentPageItems.some(column.color);
                    });

                    for (var i=0; i < currentPageItems.length; ++i) {
                        var m = currentPageItems[i];
                        var get = '';
                        if (angular.isString(m[idKey])) {
                            get = 'getItem(\'' + m[idKey] + '\')';
                        } else {
                            get = 'getItem(' + m[idKey] + ')';
                        }
                        var rowclick = '';
                        var rowLink = '';
                        var rowLinkClose = '';
                        if (scope.config.rowLink && scope.config.rowClick && m[idKey] != undefined) {
                            rowLink = '<a ng-href="{{config.rowLink(' + get + ')}}" class="ct-link" ng-click="config.rowClick(' + get + '); $event.preventDefault();">';
                            rowLinkClose = '</a>';
                            rowclick = ' ng-click="config.rowClick(' + get + ')" class="clickable"';
                        } else if (scope.config.rowClick && m[idKey] != undefined) {
                            rowclick = ' ng-click="config.rowClick(' + get + ')" class="clickable"';
                        }
                        if (scope.config.rowMouseDown && m[idKey] != undefined) {
                            rowclick = ' ng-mousedown="config.rowMouseDown(' + get + ')" class="clickable"';
                        }

                        var rc = scope.config.rowClass ? scope.config.rowClass(m) : '';
                        var rowstyle = '';
                        if (scope.config.getRowStyle) {
                            var style = scope.config.getRowStyle(i+1);
                            if (style) {
                                rowstyle = ' ' + objectToStyleExpression(style);
                            }
                        }
                        var popover = '';
                        if (scope.config.getCustomer && !$rootScope.isSmallScreen()) {
                            popover = ' ng-mouseover="showPopover(' + m.id + ')" ng-mouseleave="hidePopover()" ';
                        }

                        html += '<tr' + popover + (rc ? (' class="' + rc + '"') : '') + rowstyle + '>';
                        for (var j=0; j < columns.length; ++j) {
                            var c = columns[j];
                            if (!c.visible || c.visible(scope.config, c)) {
                                var format = c.getFormat ? c.getFormat(m) : c.format;
                                if (c.field == 'image' || (c.field.indexOf('image') != -1 && c.src) || format == 'image') {
                                    var imgSrc = c.src ? c.src(m) : $rootScope.smallMemberImage(m);
                                    var imgSize = c.size ? c.size(m) : '50px';
                                    if(imgSrc) {
                                        imgSrc = '<img style="width: ' + imgSize + '; height: ' + imgSize + '" src="' + imgSrc + '">';
                                    } else {
                                        imgSrc = '';
                                    }
                                    if (c.text) {
                                        var style = objectToStyleExpression(c.style);
                                        var text = asInertText(c.text(m));
                                        if (c.linebreak) {
                                            imgSrc = '<table><tr><td>' + imgSrc + '</td><td style="padding-left: 10px">';
                                            text = text.replaceAll('\n', '<br/>');
                                            imgSrc += '<span ' + style + '>' + text + '</span></td></tr></table>';

                                        } else {
                                            imgSrc += '<span style="margin-left: 10px"' + style + '>' + text + '</span>';
                                        }
                                    }

                                    html += '<td style="padding:2px"' + rowclick + '>' + imgSrc + '</td>';
                                } else if (format == 'editable') {
                                    var onChange = '';
                                    if (c.change && m[idKey] != undefined) {
                                        onChange = 'config.columns[{0}].change({1})'.format(j, get);
                                    }

                                    var editableType = c.editableType || 'text';
                                    var placeholder = c.editablePlaceholder ? ' placeholder="' + c.editablePlaceholder + '" ' : '';
                                    var min = c.editableType == 'number' ? ' min="0" ' : '';
                                    html += '<td><input class="form-control" data-focusid="' + focusid + '" type="' + editableType + '" ng-change="' + onChange + '" ng-model-options="{ debounce: 200 }" ng-model="' + get + '[\'' + c.field + '\']"' + placeholder + min + '></td>';
                                    ++focusid;
                                } else if (format == 'checkbox') {
                                    html += '<td><input type="checkbox" ng-change="config.columns[' + j + '].change(' + get + ')" ng-model="' + get + '[\'' + c.field + '\']" class="form-control" style="min-width: 8px; min-height: 8px; max-width: 18px; min-width: 18px; margin-left: 15%;"></td>';
                                } else {
                                    if (c.field.startsWith('xf') && !c.splitted_name) {
                                        c.splitted_name = ['xf', c.field.substr(3)];
                                    }
                                    var value = getValueForColumn(m, c);
                                    if (!c.showHtml && !formatter.requiresHtml(format)) {
                                        value = asInertText(value);
                                    }
                                    if (typeof c.style === "function") {
                                        var style = functionToStyleExpression(m, c.style);
                                    } else {
                                        var style = objectToStyleExpression(c.style);
                                    }

                                    if(showColorBox[j]) {
                                        value = withColorBox(c, m, value);
                                    }

                                    if (c.click) {
                                        rowclick = ' ng-click="config.columns[{0}].click({1})" class="clickable" '.format(j, get);
                                    }

                                    html += '<td' + style + rowclick + '>' + rowLink + value + rowLinkClose +  '</td>';
                                }
                            }
                        }

                        if (scope.config.buttons) {
                            var buttons = '<div class="' + getButtonStyle() + '" style="white-space:nowrap">';
                            for (var b=0; b < scope.config.buttons.length; ++b) {
                                var button = scope.config.buttons[b];

                                if (!button.visible || button.visible(m, scope.config)) {
                                    if (button.title) {
                                        var buttonClass = button.buttonClass || 'btn-success';
                                        var loading = button.loading ? 'ladda="config.buttons[' + b + '].loading(' + get + ')" data-style="expand-left"' : '';
                                        buttons += '<button class="btn ' + buttonClass + '" ' + loading + ' ng-click="config.buttons[' + b + '].onClick(' + get + ')" ng-disabled="config.buttons['+ b +'].disabled('+ get +')">' + $filter('translate')(button.title) + '</button>';
                                    }
                                    else {
                                        var imgSrc = buttonImageSrces[b];
                                        var tooltip = isMobile ? '' : 'tooltip="' + tooltips[b] + '"';
                                        buttons += '<a href="" ng-click="config.buttons[' + b + '].onClick(' + get + ')" ' + tooltip + '><img src="' + imgSrc + '"></img></a>';
                                    }
                                }
                            }

                            buttons += '</div>';

                            html += '<td>' + buttons + '</td>';
                        }

                        if (scope.config.multibutton) {
                            var multibutton = '<multibutton config="config.multibutton" value="' + get + '" />';
                            html += '<td>' + multibutton + '</td>';
                        }

                        html += '</tr>';
                    }

                    return html;
                };

                var renderPdf = function(summary) {
                    var deferred = $q.defer();
                    var doc = new PDFDocument();
                    var stream = doc.pipe(blobStream());

                    var x = 20;
                    var y = 20;

                    // Summary
                    var title = scope.config.getTitle && scope.config.getTitle();
                    if (title) {
                        doc.fontSize(28);
                        doc.text($filter('translate')(title), 20);
                        doc.fontSize(20);
                        var subTitle = scope.config.getSubTitle && scope.config.getSubTitle();
                        if (subTitle) {
                            doc.text($filter('translate')(subTitle), 20);
                        }

                        if (summary) {
                            doc.fontSize(14);

                            y = 130;
                            for (var i=0; i < summary.length; ++i) {
                                var s = summary[i];
                                doc.text($filter('translate')(s.title), x, y);
                                var value = s.format ? formatter.format(s.format, s.value) : s.value;
                                doc.text(value, 300, y);
                                y = doc.y;
                            }
                        }

                        if (scope.config.columns.length) {
                            doc.addPage();
                        }
                    }

                    // Headers
                    y = 20;
                    var columns = scope.config.columns;
                    for (var i=0; i < columns.length; ++i) {
                        var c = columns[i];
                        if ((!c.visible || c.visible('pdf')) && c.width) {
                            var title = $filter('translate')(c.title);
                            doc.text(title, x, y, {lineBreak: false});
                            x += c.width;
                        }
                    }

                    doc.moveDown();

                    // List of items
                    doc.fontSize(10);
                    for (var i=0; i < scope.filtered.length; ++i) {
                        var item = scope.filtered[i];
                        y = doc.y;

                        if (y > 700) {
                            doc.addPage();
                            y = 20;
                        }

                        x = 20;

                        for (var j=0; j < columns.length; ++j) {
                            var c = columns[j];
                            var visible = (!c.visible || c.visible('pdf'));
                            if (visible && c.width) {
                                var value = getValueForColumn(item, c);
                                doc.text(value, x, y);
                                x += c.width;
                            } else if (visible && c.renderPdf) {
                                c.renderPdf(doc, item);
                            }
                        }
                    }

                    doc.end();

                    stream.on('finish', function() {
                        deferred.resolve(stream.toBlob('application/pdf'));
                    });

                    return deferred.promise;
                };

                var renderExcel = function(customRows) {
                    var deferred = $q.defer();

                    var data = [];

                    // Headers
                    var columns = scope.config.getColumns ? scope.config.getColumns('excel') : scope.config.columns;
                    var headerRow = [];
                    for (var i=0; i < columns.length; ++i) {
                        var c = columns[i];
                        if ((!c.visible || c.visible('excel')) && (c.field != 'image' && c.format != 'image')) {
                            var title = $filter('translate')(c.title);
                            headerRow.push({value: title});
                        }
                    }
                    data.push(headerRow);
                    var items;
                    // List of items
                    if(customRows){
                        items = customRows
                    }
                    else{
                        items = scope.filtered
                    }
                    for (var i=0; i < items.length; ++i) {
                        var item = items[i];
                        var row = [];

                        for (var j=0; j < columns.length; ++j) {
                            var c = columns[j];
                            if ((!c.visible || c.visible('excel')) && (c.field != 'image' && c.format != 'image')) {
                                const ignoreFormat = ['price', 'keyvalue', 'htmlList'].includes(c.format);
                                var value = getValueForColumn(item, c, ignoreFormat);
                                if (c.format == 'price') {
                                    value = Number(value).toFixed(2);
                                } else if (c.format == 'keyvalue') {
                                    value = getRawValueForColumn(item, c);
                                    value = formatter.format('keyvalueLineSeparatedList', value);
                                } else if (c.format == 'htmlList') {
                                    value = getRawValueForColumn(item, c);
                                    value = formatter.format('newLineList', value);
                                }
                                row.push({value: value, format: c.format});
                            }
                        }
                        data.push(row);
                    }
                    var title = $filter('translate')(scope.config.getTitle());
                    var subTitle = scope.config.getSubTitle && scope.config.getSubTitle();
                    var excelData = createExcel(title, data, subTitle);
                    deferred.resolve(new Blob([excelData], { type: 'application/vnd.ms-excel' }));

                    return deferred.promise;
                };

                var renderJson = function(summary) {
                    var deferred = $q.defer();

                    var data = {
                        summary: summary,
                        data: []
                    };

                    var columns = scope.config.getColumns ? scope.config.getColumns('json') : scope.config.columns;

                    for (var i=0; i < scope.filtered.length; ++i) {
                        var item = scope.filtered[i];
                        var row = {};
                        for (var j=0; j < columns.length; ++j) {
                            var c = columns[j];
                            if ((!c.visible || c.visible('json')) && c.field != 'image') {
                                var value = getValueForColumn(item, c, c.format == 'price');
                                if (c.format == 'price') {
                                    value = Number(value).toFixed(2);
                                } else if (c.format == 'json') {
                                    value = JSON.parse(value);
                                }
                                row[c.field] = value;
                            }
                        }
                        data.data.push(row);
                    }

                    deferred.resolve(new Blob([angular.toJson(data)], { type: 'application/json' }));

                    return deferred.promise;
                };

                var getItemsAndSearchContinue = function(items) {
                    if (scope.config.itemFilter || scope.config.itemFilters) {
                        var filters = scope.config.itemFilters || [];
                        if (scope.config.itemFilter) {
                            filters = filters.concat([scope.config.itemFilter]);
                        }
                        var touched = false;
                        filters.forEach(function(filterFunc) {
                            if (filterFunc) {
                                items = items.filter(filterFunc, scope.config);
                                touched = true;
                            }
                        });
                        if (!touched) {
                            items = items.slice();
                        }
                        scope.items = items;
                    } else {
                        scope.items = items.slice();
                    }
                    scope.filtered = scope.items;

                    if (scope.config.searchFilter) {
                        scope.filtered = scope.filtered.filter(scope.config.searchFilter);
                    }

                    if (!scope.config.searchText) {
                    } else if (scope.config.searchField) {
                        scope.filtered = scope.filtered.filter(searchFilter, scope.config);
                    } else if (scope.config.customSearch) {
                        scope.filtered = scope.filtered.filter(function(item) { return scope.config.customSearch(item, scope.config.searchText); });
                    } else if (scope.config.customerSearch) {
                        scope.filtered = customerSearch(scope.filtered, scope.config.searchText);
                    } else {
                        scope.filtered = scope.filtered.filter(function(item) { return shallowSearch(item, scope.config.searchText, scope.config.searchDepth || 1); });
                    }

                    if (scope.orderColumn) {
                        var columnName = scope.orderColumn.replace('-', '');
                        var direction = scope.orderColumn[0] == '-' ? -1 : 1;
                        var column = _.findWhere(scope.config.columns, {field: columnName});
                        var compare;

                        const numberFormats = ['price', 'number', 'percentage', 'percent', 'percentNoMulti', 'discountedprice', 'discountedpriceleft'];

                        if (numberFormats.includes(column.format)) {
                            compare = function(a, b) { a=Number(a);b=Number(b); return a < b ? -1 : (a > b? 1 : 0); };
                        // Maybe not so elegant
                        } else if (column.field == 'invoiceNumber' || column.title == 'Verification number') {
                            compare = function(a, b) {
                                if (!isNaN(a) && !isNaN(b)) {
                                    a = Number(a);
                                    b = Number(b);
                                    return a < b ? -1 : (a > b? 1 : 0);
                                } else if (isNaN(b) && !isNaN(a)) {
                                    return -1;
                                } else if (isNaN(a) && !isNaN(b)) {
                                    return 1;
                                } else {
                                    if (a.length > 1 && b.length > 1) {
                                        if (a[0] != b[0]) {
                                            return a[0] < b[0] ? -1 : (a[0] > b[0]? 1 : 0);
                                        } else {
                                            a = Number(a.substring(1));
                                            b = Number(b.substring(1));
                                            return a < b ? -1 : (a > b? 1 : 0);
                                        }
                                    } else {
                                        return 0;
                                    }
                                }
                            };
                        }

                        scope.filtered = Array.mergeSort(scope.filtered, function(a, b) {
                            if (column.compare) {
                                return direction * column.compare(a, b);
                            } else if (compare) {
                                var aval = getRawValueForColumn(a, column);
                                var bval = getRawValueForColumn(b, column);
                                return direction * compare(aval, bval);
                            } else {
                                var aval = getValueForColumn(a, column);
                                var bval = getValueForColumn(b, column);
                                var locale = scope.config.orderOptions && scope.config.orderOptions.locale;
                                return direction * aval.localeCompare(bval, locale, scope.config.orderOptions);
                            }
                        });
                    }
                };

                var getItemsAndSearch = function() {
                    var items = scope.config.getItems() || [];
                    return $q.when(items).then(getItemsAndSearchContinue);
                };

                var setSum = function(element) {
                    var ths = $(element).find('th');
                    var tfs = $(element).find('.sum-footer th');

                    var ri = 0;
                    var hasTotal = false;
                    for (var j=0; j < scope.config.columns.length; ++j) {
                        var c = scope.config.columns[j];
                        if (!c.visible || c.visible(scope.config, c)) {
                            var sum = NaN;
                            let priceFormat = ['price', 'discountedprice', 'discountedpriceleft'].includes(c.format);
                            if (c.field != 'image' && c.showSum !== false) {
                                for (var i=0; i < scope.filtered.length; ++i) {
                                    var item = scope.filtered[i];
                                    var value = getValueForColumn(item, c, c.format == 'price' || formatter.requiresHtml(c.format));
                                    if (isNaN(value)) {
                                        sum = NaN;
                                        break;
                                    }

                                    if (value === "") {
                                        continue;
                                    }

                                    if (isNaN(sum)) {
                                        sum = 0;
                                    }
                                    sum += Number(value);
                                }
                            }
                            var title = '';
                            if (!isNaN(sum)) {
                                sum = formatter.format(priceFormat ? 'price' : 'numberNice', sum);
                                title = util.t('Total') + ' ' + sum;
                                hasTotal = true;
                            }

                            ths[ri].setAttribute('title',  title);
                            if (tfs[ri]) {
                                tfs[ri].innerHTML = title;
                                tfs[ri].setAttribute('title',  util.t(c.title));
                            }

                            ++ri;
                        }
                    }

                    $(element).find('.sum-footer')[0].style.display = hasTotal ? 'table-footer-group' : 'none';
                };

                scope.updateTable = function(resetPage) {
                    resetPage = false;

                    var focus = null;
                    try {
                        focus = document.activeElement && document.activeElement.getAttribute && document.activeElement.getAttribute('data-focusid');
                    } catch (err) {
                    }
                    if (focus) {
                        if ($(element).find(document.activeElement).length == 0) {
                            focus = null;
                        }
                    }
                    getItemsAndSearch().then(function() {
                        if (resetPage) {
                            scope.currentPage = 0; // FIXME: Always?
                        }
                        scope.groupToPages();

                        if (!scope.config.templateUrl) {
                            if (scope.renderedPlaceholders) {
                                scope.renderedPlaceholders.clear();
                            }
                            var html = renderHtml();

                            var tbody = element.find('tbody.inner-customer-table');
                            var e = angular.element(html);
                            var compiled = $compile(e)(scope);
                            tbody.empty();
                            tbody.append(compiled);

                            if (focus) {
                                $(element).find('input[data-focusid={0}]'.format(focus)).focus();
                            }

                            var isMobile = $rootScope.isMobile && $rootScope.isMobile() && scope.config.renderHtmlMobile;
                            var showHeader = (scope.config.showHeader == undefined || scope.config.showHeader) && !isMobile;
                            var showSum = scope.config.showSum === undefined ? showHeader : scope.config.showSum;

                            if (showSum) {
                                setSum(element);
                            }
                        }
                    });
                };

                scope.showPopover = function(id) {
                    var g = document.getElementById('globalpopover');
                    if (!g) {
                        g = document.createElement('div');
                        g.id = 'globalpopover';
                        document.body.appendChild(g);
                    }
                    var item = scope.getItem(id);
                    if (!item) {
                        g.style.visibility = 'hidden';
                        return;
                    }

                    var customer_id = scope.config.getCustomer(item).id;

                    if (g.dataset.id != customer_id) {
                        g.dataset.id = customer_id;
                        var html = '<customerinfo2 customer="getCustomer(' + id + ')"></customerinfo2>';
                        var e = angular.element(html);
                        var compiled = $compile(e)(scope);
                        $('#globalpopover').empty();
                        $('#globalpopover').append(compiled);
                    }

                    g.style.visibility = 'visible';
                };

                scope.getCustomer = function(id) {
                    var item = scope.getItem(id);
                    if (item) {
                        return scope.config.getCustomer(item);
                    }
                };

                scope.hidePopover = function() {
                    var g = document.getElementById('globalpopover');
                    if (g) {
                        g.style.visibility = 'hidden';
                    }
                };

                scope.searchFieldChange = function() {
                    if (scope.config.searchText) {
                        scope.updateTable(true);
                    }
                };

                scope.getNumberOfMatches = function() {
                    return scope.config.control.getNumberOfFilteredItems();
                };

                scope.internalControl = scope.control || {};
                scope.internalControl.update = function() {
                    scope.updateTable(false);
                };
                scope.internalControl.updateApi = function() {
                    updateApiItems();
                };

                scope.internalControl.rebuild = function() {
                    $timeout(function() {
                        createTable();
                        scope.updateTable(false);
                    });
                };

                scope.internalControl.getNumberOfItems = function() {
                    return scope.items && scope.items.length;
                };

                scope.internalControl.getNumberOfFilteredItems = function() {
                    return scope.filtered && scope.filtered.length;
                };

                scope.internalControl.getItems = function() {
                    return scope.items || [];
                };

                scope.internalControl.getFilteredItems = function() {
                    return scope.filtered || [];
                };

                scope.internalControl.exportTo = function(format, summary, customRows) {
                    if (format == 'html') {
                        return renderHtml();
                    }
                    else if (format == 'pdf') {
                        return pdf.load().then(function() {
                            return renderPdf(summary);
                        });
                    } else if (format == 'excel') {
                        return excel.load().then(function() {
                            return renderExcel(customRows);
                        });
                    } else if (format == 'json') {
                        return renderJson(summary);
                    }
                };

                scope.internalControl.print = function(title) {
                    var html = scope.internalControl.element?.select('table')?.outerHTML;
                    var w = window.open("", "", "width=800,height=600");
                    w.document.write(`
                                <html>
                                    <head>
                                        <title>${title}</title>
                                        <style>
                                            .row, tfoot { display: none; }
                                            table { width: 100%; border-collapse: collapse; }
                                            a { color: #000; text-decoration: none; }
                                            table, th, td { border: 1px solid black; padding: 8px; text-align: left; }
                                        </style>
                                    </head>
                                    <body onload="window.print()">
                                        ${html}
                                    </body>
                                </html>
                            `);
                    w.document.close();
                    w.print();
                }

                scope.internalControl.sendMailing = function(field, sendType) {
                    var parts = field.split('.');
                    var getObj = function(item) {
                        var value = item;
                        var i = 0;
                        while (i < parts.length-1) {
                            value = value[parts[i]];
                            i++;
                        }
                        return value;
                    };
                    var items = _.map(scope.filtered, getObj);
                    angular.forEach(items, function(item) {
                        if (!Array.isArray(item.id)) { return; }
                        for (var i=0; i < item.id.length; i++) {
                            var d = { id: item.id[i] };
                            if (item.mail) {
                                d.mail = item.mail[i];
                            }
                            if (item.phone) {
                                d.phone = item.phone[i];
                            }
                            items.push(d);
                        }
                    });
                    items = _.filter(items, function(item) { return !Array.isArray(item.id); });
                    items = _.uniq(items, function(item) { return item.id; });
                    if (sendType === 'mail') {
                        items = _.filter(items, function(item) { return item.id && item.mail; });
                    } else if (sendType === 'sms') {
                        items = _.filter(items, function(item) { return item.id && item.phone; });
                    }

                    scope.pubsub.publish('newmailingdata', {
                        sendOption: sendType,
                        receivers: items,
                        options: { 'callCloseOnSuccess': true, 'modalMode': false }
                    });
                    $modal.open({
                        templateUrl: 'views/mailingnew.html',
                        windowClass: 'huge-modal-window',
                        controller: 'NewMailingCtrl'
                    });
                };

                scope.internalControl.emptyStateVisible = function() {
                    return ((scope.filtered && !scope.filtered.length) || (scope.config.empty.visible && scope.config.empty.visible()));
                };

                scope.internalControl.element = {};
                scope.internalControl.element.select = function(selector) {
                    return element[0].querySelector(selector);
                };
                scope.internalControl.element.getColumn = function(field) {
                    var index = _.findIndex(scope.config.columns, { field: field });
                    if (index == -1) { return null; }
                    index++;
                    return element[0].querySelector('thead tr th:nth-child('+index+')');
                };
                scope.internalControl.element.getEmptyState = function() {
                    if (!scope.config.empty) { return null; }
                    if (!scope.internalControl.emptyStateVisible()) { return null; }
                    return scope.config.empty.element;
                };

                scope.config.control = scope.internalControl;

                var goOn = function() {
                    createTable();

                    if(scope.config.async) {
                        scope.updateTable(true);
                    } else {
                        scope.$watch('config.searchText', function(newValue, oldValue) {
                            if (newValue != oldValue) {
                                scope.updateTable(true);
                            }
                        });

                        scope.$watchCollection('config.getItems()', function() {
                            scope.updateTable(true);
                        });
                    }
                };


                if ($rootScope.waitFor) {
                    $rootScope.waitFor(['members', 'startedModules']).then(goOn);
                } else {
                    goOn();
                }

                var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
                    if (triggers.indexOf(message.type) != -1) {
                        if(scope.config.async) {
                            scope.setPage(scope.currentPage);
                        } else {
                            scope.updateTable(true);
                        }
                    } else if (message.type == 'module') {
                        createTable();
                        scope.updateTable(true);
                    }
                });

                var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                    createTable();
                    scope.updateTable(false);
                });

                scope.config.getSaveStateName = function() {
                    return util.getSaveStateName($location.path(), element);
                };

                scope.$on('$destroy', function () {
                    removeServerChange();
                    removeTranslateChangeSuccess();

                    var g = document.getElementById('globalpopover');
                    if (g) {
                        g.style.visibility = 'hidden';
                    }
                });
            };

            scope.updateTableDebounced = _.debounce(() => scope.updateTable(true), 10);
            scope.hideRequired = true;

            scope.$on('ApiDataLoaded', function(event, uid) {
                if (scope.renderedPlaceholders && scope.renderedPlaceholders.has(uid)) {
                    scope.updateTableDebounced();
                }
            });

            scope.$watch('config', function(newValue) {
                if (newValue) {
                    configChanged();
                }
           });
        }
    };
}]);
